import React from "react"
import Icon from "../Icon/Icon"
import {Button} from "../Button/Button"

interface AuditLogActionButtonProps {
	onClick: () => void
	small?: boolean
}

export function AuditLogActionButton({onClick, small}: AuditLogActionButtonProps) {
	if (small) {
		return (
			<Button
				size="small"
				variant="subtle"
				prefixIcon="clock-cycle-twenty-four-hour--business-products"
				onClick={onClick}
			>
				Audit Log
			</Button>
		)
	}

	return (
		<button className="button page-title-button" onClick={onClick}>
			<Icon icon={"clock-cycle-twenty-four-hour--business-products"} size={12} />
			<span>Audit Log</span>
		</button>
	)
}
export default AuditLogActionButton
